import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection, Scrolling
    , Export, Summary, TotalItem,
    GroupPanel,
    Grouping,
    GroupItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import { parseDate } from "../../utils/Utils";

const TesvikFarkRaporDetay = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Teşvik Rapor Fark";
    const [store, setStore] = useState(null);


    useEffect(() => {

        setStore(getStore());
    }, [])

    let dataGrid = null;


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                if (props.data != null && props.data.length > 0) {
                    props.data.map(d => {
                        d.hesapDonemTar = parseDate(d.hesapDonemTar);
                        d.donemBas = parseDate(d.donemBas);
                        d.donemBit = parseDate(d.donemBit);
                        d.iseBaslamaTar = parseDate(d.iseBaslamaTar);
                        d.istenAyrilisTar = parseDate(d.istenAyrilisTar);

                        //d.fark = parseFloat(d.primDestegiYuzde5Haric).toFixed(2) - parseFloat(d.primDestegi).toFixed(2);
                    });
                }


                return props.data;
            }
        });
    }


    function siraRender(data) {
        return (data.rowIndex + 1);// <b>{(data.rowIndex +1)}</b> ;
    }



    return (
        <div >
            <DataGrid
                ref={ref => dataGrid = ref}
                width="100%"
                height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'parent.domain.name'} width={200} caption={'Firma'} dataType="string" visible={true} groupIndex={0} />
                <Column dataField={'parent.domain.sicilNo'} width={100} caption={'SicilNo'} dataType="string" visible={true} groupIndex={1} />
                <Column dataField="hesapDonemTar" width={70} caption={'Hesap-Dönem'} dataType="date" format="yyyy/MM" visible={true} groupIndex={2} />


                <Column dataField={'personelTcKimlik'} width={90} caption={'Tck No'} dataType="string" mappingType="String" visible={false} />
                <Column dataField={'personelAdi'} minWidth={90} width={90} caption={'Adı'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelSoyadi'} minWidth={90} width={90} caption={'Soyadı'} dataType="string" mappingType="String" visible={true} />


                <Column dataField={'belgeTuru'} width={40} caption={'Belge Çeşidi'} dataType="String" visible={true} />
                <Column dataField={'beyanKanunNo'} width={70} caption={'Firma-Kanun'} dataType="String" visible={true} />
                <Column dataField="kanunNo" width={70} caption={'Danışman-Kanun'} dataType="string" visible={true} />

                <Column dataField="primDestegi" width={60} caption={'Firma-Tutar'} dataType="number" visible={true} />
                <Column dataField="primDestegiYuzde5Dahil" width={60} caption={'Teşvik-Tutar'} dataType="number" visible={true} />
                <Column dataField="fark" width={60} caption={'Fark'} dataType="number" visible={true} />
                <Column dataField="hazineIndirim" width={60} caption={'Hazine İndirim'} dataType="number" visible={true} />




                <Column dataField="donemBas" width={70} caption={'Başlangıç'} dataType="date" format="yyyy/MM" visible={false} />
                <Column dataField="donemBit" width={70} caption={'Bitiş'} dataType="date" format="yyyy/MM" visible={false} />

                <Column dataField={'ucret'} width={60} caption={'Ücret'} dataType="number" visible={false} />
                <Column dataField={'ikramiye'} width={60} caption={'İkramiye'} dataType="number" visible={false} />
                <Column dataField={'gun'} width={40} caption={'Gün'} dataType="number" visible={false} />

                <Summary>
                    <GroupItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        //alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    {/* <GroupItem
                        column="primDestegiYuzde5Haric"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        //alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />

                    <GroupItem
                        column="primDestegi"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        //alignByColumn={true}
                        displayFormat="Toplam: {0} TL" /> */}

                    {/* <TotalItem
                        column="fark"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="primDestegiYuzde5Haric"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        displayFormat="Toplam: {0} TL" />
                    <TotalItem
                        column="primDestegi"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        displayFormat="Toplam: {0} TL" /> */}
                </Summary>




            </DataGrid>



        </div>
    )
}

export default TesvikFarkRaporDetay;
